import {Repository} from '@s-ui/domain'

/**
 * @implements Repository
 */
export default class EmptyTrackingRepository extends Repository {
  async identifyUser() {}

  async checkIfUserIsIdentified() {}

  async getExpiredSession() {}

  async removeSession() {}
}
